import { Card, Image } from 'react-bootstrap'
import AppLoader from 'components/general/AppLoader';
// import { ArrowRightCircle } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
// import headerImg from '../../assets/logos/TMLogo.png'

import { fetchWrapper } from '_helpers/fetch-wrapper'
import { getMeetingCardDisplayAssignment } from '../../_helpers/meetingCardDisplay'

export const NextMeeting = ({ fixedBottom = false }) => {

  const [isLoading, setIsLoading] = useState(true)
  const [meeting, setMeeting] = useState(null)
  const [displayRole, setDisplayRole] = useState('')

  const url = process.env.REACT_APP_URL
  const navigate = useNavigate()

  const getMeetings = async () => {
    setIsLoading(true)
    try {
      const response = await fetchWrapper.get(`${url}/meetings/comingup`)
      setMeeting(response)
      // console.log('response', response)
    }
    catch (e) {
      console.log('Next meeting: ' + e)
    }
    // console.log(meeting)
    setIsLoading(false)
  }

  const effectiveDisplayRole = meeting?.meetingCardDisplayRole || displayRole
  const displayAssignment = getMeetingCardDisplayAssignment(meeting?.roleAssignments, effectiveDisplayRole)
  const displayRoleLabel = String(displayAssignment.roleLabel || 'Role').toUpperCase()

  useEffect(() => {
    getMeetings()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    fetchWrapper.get(`${url}/meetingsConfig`)
      .then((config) => {
        if (!meeting?.meetingCardDisplayRole && (config?.meetingCardDisplayRole || (Array.isArray(config?.meetingCardDisplayRoles) && config.meetingCardDisplayRoles.length > 0))) {
          setDisplayRole(config.meetingCardDisplayRole || config.meetingCardDisplayRoles[0])
        }
      })
      .catch(() => setDisplayRole(''))
  }, [url, meeting?.meetingCardDisplayRole])

  return (
    <>
      {
        (meeting) &&
        <Card className={`text-center next-meeting meetings-mock-card-shell frontpage-next-meeting-card ${fixedBottom ? 'next-meeting-hints-style next-meeting-fixed-bottom' : ''}`} >
          {
            (isLoading)
              ?
              <AppLoader />
              :
              <Card.Body onClick={() => {
                const target = (meeting && meeting._id) ? `/meeting/${meeting._id}` : '/meetings/'
                navigate(target)
              }} className='meetings-mock-card-body' style={{ cursor: 'pointer' }}>
                <div className='meetings-mock-card'>
                  <div className='meetings-mock-top'>
                    <div className='meetings-mock-date-group'>
                      <span className='meetings-mock-date'>
                        {meeting?.meetingDate || ''}
                      </span>
                      {meeting?.meetingNumber && (
                        <span className='meetings-mock-number'>
                          #{meeting.meetingNumber}
                        </span>
                      )}
                    </div>
                    <span className='meetings-mock-next-badge'>NEXT</span>
                  </div>

                  <div className='meetings-mock-avatar'>
                    {displayAssignment.avatar
                      ? <Image src={displayAssignment.avatar} alt='Assigned role avatar' />
                      : displayAssignment.initials
                        ? <span className='meetings-mock-avatar-fallback'>{displayAssignment.initials}</span>
                        : <i className='bi bi-person-fill meetings-mock-avatar-fallback'></i>}
                  </div>

                  <h3 className='meetings-mock-title'>{meeting?.meetingTheme || 'Next Meeting'}</h3>
                  <div className='meetings-mock-separator'></div>
                  <div className='meetings-mock-role-label'>{displayRoleLabel}:</div>
                  <div className='meetings-mock-role-name'>{displayAssignment.displayName}</div>
                </div>
              </Card.Body>
          }
        </Card>
        // </OverlayTrigger>
      }
    </>
  )
}